import type { CellContext } from '@tanstack/react-table'

import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { Transaction } from '@/modules/projects'
import { cn } from '@/utils'

export const KindBadgeCell = (cell: CellContext<Transaction, string>) => {
  const kind = cell.getValue()
  const searchQuery = cell.table.options.meta?.searchQuery
  const styles = {
    debit: 'text-red-700 border-red-200 bg-red-50',
    credit: 'text-emerald-700 border-emerald-200 bg-emerald-50',
  }

  const normalizedKind = (kind || '').toLowerCase()
  const defaultStyle = 'text-slate-700 border-slate-200 bg-slate-50'
  const style = styles[normalizedKind as keyof typeof styles] || defaultStyle

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border capitalize',
        style,
      )}
    >
      <HighlightText text={kind} query={searchQuery} />
    </span>
  )
}
